import { LocationsStore } from '../store/locations.store';
import { inject } from '@angular/core';

export const locationsLoadedGuard = () => {
  const locationsStore = inject(LocationsStore);
  if (!locationsStore.allLoaded() && !locationsStore.isLoading() && !locationsStore.error()) {
    locationsStore.load();
  }
  return true;
};
